import { OnBoardingType, OnBoardingRole } from '@app/entities/enums/user/user.enum';

export class UserOnBoarding {
  type!: OnBoardingType;
  role!: OnBoardingRole;
  companyCode!: string;
  completed!: boolean;
}
